export default __webpack_public_path__ + "static/media/KHInterference-Bold.73e365a8.otf";